module.exports = __webpack_public_path__ + "static/img/icon_store_tab_sel.9124cde.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_store_tab_sel.png
// module id = +hOH
// module chunks = 1